module.exports = __webpack_public_path__ + "static/media/menu-icon-black.8570217f.svg";